


























import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeLongueursVente, {LongueursVenteFilter} from '@/stores/modules/longueursVente';

import TrueFalseMultiSelect from '@/components/Input/TrueFalseMultiSelect.vue';

@Component({
	components: {
		TrueFalseMultiSelect,
	}
})
export default class CrudLongueursVenteFilter extends Vue {
	
	@Prop({ type: Boolean, default: false}) reduce;
	
	@Stored(() => storeLongueursVente) private page!: number;
	@Stored(() => storeLongueursVente) private filters!: LongueursVenteFilter;
	
	@WatchObjectProperties('filters', LongueursVenteFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeLongueursVente.dispatch('getC', { filters: true });
	}
	
}
